import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=40184ac1&lang=pug&"
import script from "./Area.vue?vue&type=script&lang=ts&"
export * from "./Area.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports